import axios from 'axios'
import isEmpty from 'lodash/isEmpty'
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from '../../shared/vars'

export const contentLoading = () => {
    return {
        type: 'CONTENT_LOADING'
    }
}

export const contentHasError = (err) => {
    return {
        type: 'CONTENT_HAS_ERROR',
        errors: err
    }
}

export const contentSuccess = (data) => {
    return {
        type: 'CONTENT_SUCCESS',
        data
    }
}

export function getContent(permalink) {
    return (dispatch) => {
        dispatch(contentLoading())

        const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY }

        return axios.get(REACT_APP_API_URL + 'pages/' + permalink, { headers: AUTH_HEADER })
            .then((response) => {
                // Error explicitly set
                if (!isEmpty(response.data.errors)) {
                    dispatch(contentHasError(response.data.errors))

                    // Error status
                } else if (!!response.data.status && response.data.status !== 200) {
                    dispatch(contentHasError({ 'general': response.data.message }))

                    // Success
                } else {
                    dispatch(contentSuccess(response.data))
                }
            })
            .catch((err) => {
                console.log('eNews error:', err.response)
                dispatch(contentHasError(err.response.data.message))
            })
    }
}



// WEBPACK FOOTER //
// ./src/store/actions/content.js